import { api } from "../api";

/**
 * findAllLastTemPositionsExport - Function that finds on database the last ten positions by vehicle and export in a PDF/XSLX file
 * /vehicles/grid/{customerId}/{departmentId}/{id}/{type}/export   
 * method GET 
 * @async-function
 */
const findAllLastTemPositionsExport = async (token: string, customerId: number, departmentId: number, id: number, type: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/vehicles/grid/${customerId}/${departmentId}/${id}/${type}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllLastTemPositionsExport;